import React from "react";
import { MethodRow } from "../method-row/MethodRow";
import * as styles from "./OptionRowAdd.module.scss";
import { MethodIcon } from "../method-row/MethodIcon";
import { PlusIcon } from "@picklebet/ui";

export const OptionRowAdd = ({
  label,
  onClick,
}: {
  label: React.ReactNode;
  onClick: () => void;
}) => {
  return (
    <MethodRow
      as="button"
      className={styles.optionRowAdd}
      label={label}
      onClick={(event) => {
        if (event.defaultPrevented) return;
        onClick();
      }}
      icon={
        <MethodIcon className={styles.icon}>
          <PlusIcon />
        </MethodIcon>
      }
    />
  );
};
